import { useState } from 'react';

import { CustomAlert, Text } from '../../../../../shared/uiComponents';
import { Copy } from '../../../../../shared/Assets/svgIcons';
import CopyAuthorizationContent from './copyAuthorizationContent';

import { ActiveAuthorizationProperties } from '../../../../../redux/API/ClientAPIHelpers/insuranceAuthorizationProperties';

const CopyAuthorization = ({ authorizationData }: { authorizationData: ActiveAuthorizationProperties }) => {
	const [editOpen, setEditOpen] = useState<boolean>(false);

	const editHandler = () => {
		setEditOpen(true);
	};

	return (
		<>
			<div className="actionIcon" onClick={editHandler}>
				<Copy />
			</div>
			<div className="actionContent" onClick={editHandler}>
				<Text title="Copy" type="psm" fontWeight="medium" />
			</div>
			<CustomAlert
				open={editOpen}
				onClose={() => setEditOpen(false)}
				title="Copy Insurance Authorization"
				Content={({ onClose }) => <CopyAuthorizationContent authorizationData={authorizationData} onClose={onClose} />}
			/>
		</>
	);
};

export default CopyAuthorization;
